// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kxJfS","col":"styles_col__3Yl5g"};